import { Star } from "lucide-react";

export default function CaseStudyThumbnail({ study, centerMetric = false, compact = false, whiteBackground = false }) {
  return (
    <div className={`relative flex ${compact ? 'aspect-video p-5' : 'aspect-[4/3] p-8'} flex-col ${centerMetric ? 'justify-center' : 'justify-between'} gap-6 rounded-3xl ${whiteBackground ? 'bg-white' : 'bg-gradient-to-br from-blue-50 via-white to-cyan-100/60'} ring-1 ring-inset ring-neutral-900/5`}>
      <span className={`${centerMetric ? 'absolute left-8 right-8 top-8 ' : ''}flex items-center gap-2 text-sm font-semibold text-vblue3`}>
        <Star aria-hidden="true" className="size-4 shrink-0 fill-current" />
        {study.client}
      </span>
      <div>
        <p className={`${compact ? 'text-4xl' : 'text-[clamp(2.5rem,5vw,4.5rem)]'} font-bold leading-none tracking-tight text-black`}>
          {study.stats[0].value}
        </p>
        <p className="mona mt-4 text-xs font-bold uppercase tracking-widest text-black">{study.stats[0].label}</p>
      </div>
    </div>
  );
}
